import { useEffect, useState } from "react";
import { scrollToSection } from "../lib/scroll";

const LINKS = [
    { id: "legacy", label: "Legacy" },
    { id: "founders", label: "Founders" },
    { id: "craft", label: "Craft" },
    { id: "development", label: "In Development" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 32);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (e, id) => {
        e.preventDefault();
        scrollToSection("#" + id);
    };

    return (
        <header
            data-testid="site-nav"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "border-b border-gold/15 bg-ink/85 backdrop-blur-md"
                    : "border-b border-transparent"
            }`}
        >
            <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
                <a
                    href="#top"
                    data-testid="nav-logo-link"
                    onClick={(e) => go(e, "top")}
                    className="flex items-center gap-3"
                >
                    <img
                        src="/favicon-512.png"
                        alt="Mountain View Pictures mark"
                        className="h-9 w-9 rounded-[5px] object-contain ring-1 ring-white/10"
                    />
                    <span className="flex flex-col items-center leading-none">
                        <span
                            data-testid="nav-wordmark"
                            className="font-label text-[10px] tracking-[0.3em] text-cream/90"
                        >
                            MOUNTAIN<span className="text-gold">VIEW</span>
                        </span>
                        <span className="mt-1 font-label text-[7px] tracking-[0.46em] text-cream/55">
                            PICTURES
                        </span>
                    </span>
                </a>
                <div className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={"#" + l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={(e) => go(e, l.id)}
                            className="nav-link font-label text-[10px] uppercase tracking-[0.35em] text-cream/60 transition-colors duration-300 hover:text-gold"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#contact"
                        data-testid="nav-link-contact"
                        onClick={(e) => go(e, "contact")}
                        className="nav-link font-label text-[10px] uppercase tracking-[0.35em] text-gold"
                    >
                        Contact
                    </a>
                </div>
                <a
                    href="#contact"
                    data-testid="nav-link-contact-mobile"
                    onClick={(e) => go(e, "contact")}
                    className="font-label text-[10px] uppercase tracking-[0.35em] text-gold md:hidden"
                >
                    Contact
                </a>
            </nav>
        </header>
    );
}
